import React from 'react';
import { useEffect, useState } from 'react';
import Button from '../common/ui-components/input/Button';
import styles from '../../styles/modules/components/SelfServe/copay-summary.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import {formatNumber} from '../../utils/index';
import { connect } from 'react-redux';
import {CopayCheckout, CopaySuccess} from '../../api/selfserve';
import { isIproPlan, srPayLoad } from '../../utils/selfserve';
import {CreateTicket} from '../../api/selfserve';
import { useDispatch } from 'react-redux';
import {changeProgress,updateSuccessData, updateFailureData, changeTrackerState} from '../../redux/actions/selfserveActions';
import {showQuckAlert} from '../../redux/actions/genericActions';
import { makePayment, termsofServiceClicked } from '../../tracking/selfserveTracking';
import { cleverTapTrigger } from '../../tracking/segment';
import Checkbox from '../common/ui-components/input/Checkbox';
import router from 'next/router';
import CopayAfterSrConfirmationAlert from './CopayAfterSrConfirmationModal';
import { isCopayAfterSr } from '../../utils/selfserve';

interface ReduxStateProps {
    selfserveReducer: any,
}


interface MainProps {

    setPageLoading: (data:Boolean) => void
}

type Props = ReduxStateProps & MainProps;

const CopaySummary = (props: Props) => {
    const [checkbox, setCheckbox] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const setCheckboxValue = () =>{
        setCheckbox(!checkbox);
    }

    const setModalOpen = () =>{
        setIsModalOpen(false)
    }

    const dispatch:any = useDispatch()
    useEffect(() => {
        dispatch(changeTrackerState(3));
        window.scrollTo({top:0,left:0,'behavior': 'smooth'});
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js'
        script.async=true;
        document.body.appendChild(script);

    }, [])

    const createSrPayLoad = (data, temp_sr,whatsapp) => {

       return srPayLoad(data,temp_sr=temp_sr, whatsapp);

    }

    // Create Ticket API call Function
    const createSR: any = () => {
        props.setPageLoading(true);
        const whatsappOptIn = props.selfserveReducer.whatsAppOptIn;
        const postData:any = createSrPayLoad(props.selfserveReducer, false, whatsappOptIn);
        CreateTicket({
            "application": "website",
            "data": postData
        }).then((res:any) => { 
            
            if (res.data.is_valid){
                dispatch(updateSuccessData(res.data))
                dispatch(changeProgress(10));
                props.setPageLoading(false);
            }else {
                dispatch(updateFailureData(res.data));
                dispatch(changeProgress(11));
                // SR FAILUR
                props.setPageLoading(false);
                cleverTapTrigger('Raise SR Failure', {'osid':props.selfserveReducer?.planDetails?.osid, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
            }
        })
    }

    const callbackRazorPay = (data, status) => {

        props.setPageLoading(true);

        if (status == "success") {
            CopaySuccess({
                'application': 'website',
                'gateway': 'razorpay',
                data: data
            }).then((res: any) => {
                // loader off
                if (res.data.is_valid) {
                    cleverTapTrigger('Copayment Success', {'status':'success','osid':props.selfserveReducer?.planDetails?.osid,'sr_id':res.data?.ticket_creation_ref_id, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
                    cleverTapTrigger('Raise SR Success',{'osid':props.selfserveReducer?.planDetails?.osid,'sr_id':res.data?.ticket_creation_ref_id, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
                    dispatch(updateSuccessData(res.data))
                    dispatch(changeProgress(10));
                    props.setPageLoading(false);

                } else {
                    cleverTapTrigger('Copayment Failure', {'status':'failure','osid':props.selfserveReducer?.planDetails?.osid, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
                    dispatch(updateFailureData(res.data))
                    dispatch(changeProgress(11));
                    props.setPageLoading(false);
                }
            })
                .catch((err: any) => {
                    props.setPageLoading(false);
                    //(err);
                    console.log(err)
                })
        } else {
            props.setPageLoading(false);
            cleverTapTrigger('Copayment Failure', {'status':'failure','osid':props.selfserveReducer?.planDetails?.osid, 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type})
            dispatch(showQuckAlert({
                text: "An error occured while processing your request. Please try again after some time.",
                type: 'error',
                hideAfter: 5000
            }));
        }
    }

    const handleChekOut:any = (e,amount) => {

        e.preventDefault();
        // Checkout PayLoad
        makePayment(); //gtm trackign event
        const data = {
            token_id:props.selfserveReducer.token_id,
            cover_id: props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0].cover_id,
            amount: amount,
            osid: props.selfserveReducer.planDetails.osid,
            onsite_temp_sr_id: props.selfserveReducer.serviceRequests[0].temp_sr_id,
            ref_no: null
        }
        // CheckOut API Call
        CopayCheckout({

            'application': 'website',
            'gateway': 'razorpay',
            data: data

        }).then((res:any) => {
            
            const options = {

                key: res.data.key,
                amount: parseInt(res.data.amount) * 100,
                description: res.data.description,
                order_id: res.data.txnid,
                cust_payment_id : res.data.cust_payment_id,
                prefill: {
                    email: res.data.email,
                    contact: res.data.phone,
                },
                theme: { color: "#00aaa1" },
                handler: (resp:any) => {
                    callbackRazorPay(
                        {
                            ...resp,
                            token_id:props.selfserveReducer.token_id,
                            amount: res.data.amount,
                            ref_no: null,
                            onsite_temp_sr_id: props.selfserveReducer.serviceRequests[0].temp_sr_id,
                            cust_payment_id: res.cust_payment_id
                        },
                          "success"
                    );
                },
                "modal.ondismiss": () => {
                    callbackRazorPay("razorpay_response_data", "failed");
                },
            }
            const rzp1 = new window.Razorpay(options);
            rzp1.open()

        }).catch((err:any) => {

            dispatch(showQuckAlert({
                text: "An error occured while processing your request. Please try again after some time.",
                type: 'error',
                hideAfter: 5000
            }));
            console.log(err);
        })
    }
    let copayAmount = props.selfserveReducer.copaymentDetails.copayment_amount;
    let copay_description = props.selfserveReducer.copaymentDetails.new_copay_disclaimer;
    let copay_description_note = props.selfserveReducer.copaymentDetails.copay_disclaimer_note;
    const planName = props.selfserveReducer.planDetails.plan_title;
    const customerName = props.selfserveReducer.planDetails.order.name;
    const devicePrice = props.selfserveReducer.planDetails.device_detail.device_price ? props.selfserveReducer.planDetails.device_detail.device_price: props.selfserveReducer.planDetails.device_price;

    return (

        <div className={styles.confirm_parent}>

            <div className={commonStyles.top_heading}>
                <h5>Order Summary</h5>
            </div>

            <p className={styles.device_detail}><span className={styles.device_name}>{props.selfserveReducer.planDetails.device_detail.category}</span><span className={styles.brand_name}>{`${props.selfserveReducer.planDetails.device_detail.brand} ${props.selfserveReducer.planDetails.device_detail.model}`}</span></p>

            <div className={styles.table_parent}>

                <div className={`${styles.rows} row`}>
                    <p className={`${styles.heading_one} col-4`}>Item</p>
                    <p className={`${styles.heading} col-2`}>Qty</p>
                    <p className={`${styles.heading} col-3`}>Amount</p>
                    <p className={`${styles.heading} col-3`}>Total</p>
                </div>

                <div className={`${styles.rows} row`}>
                    <p className={`${styles.left_align} col-4`}>{`Copayment ${props.selfserveReducer.planDetails.device_detail.brand} ${props.selfserveReducer.planDetails.device_detail.model}`}</p>
                    <p className={`${styles.center_align} col-2`}>1</p>
                    <p className={`${styles.center_align} col-3`}>₹{copayAmount}</p>
                    <p className={`${styles.center_align} col-3`}>₹{copayAmount}</p>
                </div>

                

            </div>

            <div className={`${styles.order_total} row`}>

                    <p className={`${styles.heading} col-4`}>Total</p>
                    <p className={`${styles.heading_center} col-2`}>1</p>
                    <p className={`${styles.heading_center} col-3`}></p>
                    <p className={`${styles.heading_center} col-3`}>₹{copayAmount}</p>

            </div>

            <div className={styles.copay}>
            {copay_description && (
                <p dangerouslySetInnerHTML={{ __html: `*${copay_description}` }} />
            )}
            {copay_description_note && (
                <p dangerouslySetInnerHTML={{ __html: `Note: ${copay_description_note}` }} />
            )}
            <p>For more details, refer{' '}
                  <a
                    href={`/terms-of-service?osid=${props.selfserveReducer.planDetails.tokenized_osid}`}
                    target="_blank"
                    rel="noopener noreferrer" 
                    onClick={(e) => {
                      cleverTapTrigger("Terms of Service Clicked",{"page name":"Copay Summary"})
                      e.stopPropagation();
                    }}
                  >
                    <i>Terms of Service</i>
                  </a>
                </p>
                {props.selfserveReducer.isServicePGChargesApplicable && (
                <p className={styles.payment}>*A convenience fee will be charged by Onsitego depending on your choice of payment method</p>
                )}
            </div>
            

            {!['Self-Repair'].includes(props.selfserveReducer.appointmentProcessType.processType) && isCopayAfterSr(router) && (
                <div className={styles.checkbox}>
                <Checkbox name="checkbox" id="checkbox" checked={checkbox} onChange={setCheckboxValue}  /> Customer has agreed to pay the copay amount.
                 </div>)}
            {!['Self-Repair'].includes(props.selfserveReducer.appointmentProcessType.processType) ? 
                (<div>
                            {isCopayAfterSr(router) ? 
                            <div className={`${commonStyles.button_actions_sticky} ${styles.salespro_copay_button_div}`}>
                                 <Button className={styles.salespro_copay_button} disabled={!checkbox} text={"Next"} onClick={()=>{setIsModalOpen(true)}}/>
                            </div>
                            :
                            <a role="button" href='#' className={`${styles.copay_button}  row`} onClick={(e: React.MouseEvent<HTMLAnchorElement>) => { handleChekOut(e, copayAmount)}}>
                                <div className={`${styles.first_col} col-8`}>
                                    <p className={styles.total_text}>Total Amount</p>
                                    <p className={styles.amount}>₹{copayAmount}</p>
                                    <p className={styles.taxes}>{props.selfserveReducer.isServicePGChargesApplicable ? '+ Fee*' : '(Inclusive of all taxes)'}</p>
                                </div>

                                <div className='col-4'>
                                    <p className={styles.pay_now}>Pay Now</p>
                                </div>
                            </a>
                        }
                

                </div>) : 
                (
                    <div className={commonStyles.button_actions_sticky}>
                        <Button
                            disabled={false}
                            className={commonStyles.cart_btn}
                            style={{"width": "300px"}}
                            text={"Raise Service Request"}
                            variant='primary'
                            onClick={() => {createSR()}}
                        />
                    </div>
                )
            }
            <CopayAfterSrConfirmationAlert is_open={isModalOpen} closeModal={setModalOpen} confirm = {() => {createSR()}}/>
        </div>

    )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(CopaySummary);
